export default "/images/asset-default-image.385327.png";